import { Component, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { DtisFooterComponent, type RailBarRouteConfig } from '../../../..';
import type { HeaderDropdownConfig } from '../dtis-header/dtis-header.component';
import { DtisHeaderComponent } from '../dtis-header/dtis-header.component';
import { DtisRailNavbarComponent } from '../dtis-rail-navbar/rail-navbar.component';

@Component({
  selector: 'dtis-shell',
  templateUrl: './dtis-shell.component.html',
  imports: [DtisHeaderComponent, RouterModule, DtisFooterComponent, MatProgressSpinnerModule, DtisRailNavbarComponent],
})
export class DtisShellComponent {
  /**
   * The title which get passed into the header
   */
  readonly title = input.required<string>();
  /**
   * The current version of the application
   */
  readonly appVersion = input.required<string>();
  /**
   * An Array of keyvalue pairs for the footer
   */
  readonly footerMetaConfig = input([]);
  /**
   * Signal that emits the configuration for the header.
   */
  readonly headerConfig = input([]);
  /**
   * Configuration for the slim bar navigation.
   * It includes an array of routes and a flag to hide the slim bar.
   * The routes are defined as an array of objects with properties like name, icon, and route.
   * The isHidden property determines whether the slim bar is visible or not.
   * @type {Signal<{ isHidden?: boolean; routes: routeItem[] }>}
   */
  readonly railConfig = input<RailBarRouteConfig>({
    isHidden: false,
    routes: [],
  });
  /**
   *
   */
  readonly header_links = input<
    {
      callback?: Function;
      routerLink?: string[];
      tooltip: string;
      icon: string;
    }[]
  >([]);
  /**
   * Optional custom dropdown rendered in the header (e.g. plant switcher).
   */
  readonly headerDropdown = input<HeaderDropdownConfig | undefined>(undefined);
  /**
   * Additional custom dropdowns rendered alongside the primary header dropdown.
   */
  readonly headerDropdowns = input<HeaderDropdownConfig[]>([]);
  /**
   * Optional readonly label displayed next to the header dropdown.
   */
  readonly headerReadonlyLabel = input<string | undefined>(undefined);
  /**
   * the event emitter for the debug button
   */
  toggleDebug = output();

  /**
   * Enable sidebar + detail layout mode.
   * When true, content projection with [sidebar] selector is expected.
   * When false (default), uses traditional full-width layout with padding.
   */
  readonly useSidebarLayout = input<boolean>(false);
}
